import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';
import PropTypes from 'prop-types';

import ErrorMessage from './ErrorMessage';
import { VGSInputStyle } from './VGS.styles';

const VGSInputStyled = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isError'
})(VGSInputStyle);

function VGSFieldWithMessage({ isError, message, id }) {
  return (
    <Stack
      flexGrow
      gap="4px"
      width="100%"
    >
      <VGSInputStyled
        id={id}
        isError={isError}
        sx={{
          iframe: {
            width: '100%'
          }
        }}
      />
      {isError && <ErrorMessage message={message} />}
    </Stack>
  );
}

VGSFieldWithMessage.propTypes = {
  id: PropTypes.string,
  isError: PropTypes.bool,
  message: PropTypes.string
};

export default VGSFieldWithMessage;
